<template>
    <div v-if="style" :style="style" ref="lavContainer" class="lottie" />
</template>

<script>
import lottie from 'lottie-web';
import axios from 'axios';

export default {
    props: {
        path: {
            required: true,
        },
        speed: {
            type: Number,
            required: false,
            default: 1,
        },
        width: {
            type: Number,
            required: false,
            default: -1,
        },
        height: {
            type: Number,
            required: false,
            default: -1,
        },
        loop: {
            type: Boolean,
            required: false,
            default: false,
        },
        autoPlay: {
            type: Boolean,
            required: false,
            default: false,
        },
        loopDelayMin: {
            type: Number,
            required: false,
            default: 0,
        },
        loopDelayMax: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    data: () => ({
        name: 'lottie-animation',
        rendererSettings: {
            scaleMode: 'centerCrop',
            clearCanvas: true,
            progressiveLoad: false,
            hideOnTransparent: true,
        },
        anim: null,
        style: null,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async loadJsonData(path) {
            return await axios.get('/' + path).then(response => {
                return response.data;
            });
        },
        async init() {
            this.style = {
                width: this.width != -1 ? `${this.width}px` : '100%',
                height: this.height != -1 ? `${this.height}px` : '100%',
                overflow: 'hidden',
                margin: '0 auto',
            };

            let jsonData = await this.loadJsonData(this.path);

            if (this.anim) {
                this.anim.destroy(); // Releases resources. The DOM element will be emptied.
            }

            this.anim = lottie.loadAnimation({
                container: this.$refs.lavContainer,
                renderer: 'svg',
                loop: this.loop,
                autoplay: this.autoPlay,
                animationData: jsonData,
                rendererSettings: this.rendererSettings,
            });

            this.$emit('AnimControl', this.anim);
            this.anim.setSpeed(this.speed);
        },
        playLoop() {
            this.anim.play();
            this.anim.addEventListener('complete', this.play);
        },
        play() {
            this.anim.stop();
            this.anim.setDirection(1);
            this.anim.play();
        },
        playReverse() {
            this.anim.setDirection(-1);
            this.anim.play();
            this.anim.removeEventListener('complete', this.play);
        },
        pause() {
            this.anim.pause();
        },
        stop() {
            this.anim.stop();
        },
        onComplete() {
            console.log('anim finished');
        },
        triggerPathFill(color) {
            const pathes = this.$refs.lavContainer.querySelectorAll('path');
            pathes.forEach(element => {
                element.style.fill = color;
            });
        },
    },
    /* eslint-disable */
    computed: {
        activeSectionName() {
            return this.$store.getters.activeSectionName;
        },
    },
    watch: {
        path: function(newVal, oldVal) {
            this.init();
        },
    },
    activeSectionName: {
        activeSectionName(newVal, oldVal) {
            console.log('stop all lottie containers');
            this.anim.stop();
        },
    },
};
</script>
